import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EventAttendee } from '@models/event-attendance/event-attendee.model';
import { RSVPOptionType } from '@models/event-attendance/rsvp-option-type.enum';
import { EventRSVPConfirmationPageSectionType } from '@models/events/event-rsvp-confirmation-page-section-type.enum';
import { EventRsvpConfirmationPage } from '@models/events/event-rsvp-confirmation-page.model';
import { EditSocialMediaButtonsComponent } from '@modules/events/components/edit-social-media-buttons/edit-social-media-buttons.component';
import { AfterAttendeeSectionType } from '@modules/events/dialogs/generic-after-attend-event/generic-after-attend-event.dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../../../../../pipes/safe-html.pipe';
import { AppRoutes } from '../../../../../../routes';

@Component({
  selector: 'app-generic-after-attend-section-card',
  standalone: true,
  imports: [SafeHtmlPipe, EditSocialMediaButtonsComponent, TranslateModule],
  templateUrl: './generic-after-attend-section-card.component.html',
  styleUrl: './generic-after-attend-section-card.component.scss',
})
export class GenericAfterAttendSectionCardComponent {
  @Input() type?: AfterAttendeeSectionType;
  @Input() rsvpType?: RSVPOptionType;
  @Input() attendee?: EventAttendee;
  @Input() eventRsvpConfirmationPage?: EventRsvpConfirmationPage;
  @Output() onClose = new EventEmitter();

  constructor(
    private router: Router,
    private translateService: TranslateService,
  ) {}

  getIcon() {
    switch (this.type) {
      case AfterAttendeeSectionType.PARTICIPANTS: {
        return this.rsvpType === RSVPOptionType.NO
          ? '<i class="fa-regular fa-circle-xmark"></i>'
          : '<i class="fa-regular fa-circle-check"></i>';
      }
      case AfterAttendeeSectionType.SIGN_UP: {
        return '<i class="fa-regular fa-id-card-clip"></i>';
      }
      case AfterAttendeeSectionType.SOCIAL_MEDIA: {
        return '<i class="fa-regular fa-users"></i>';
      }
      default:
        return '';
    }
  }

  goToSignUp() {
    this.router.navigate(['/', AppRoutes.Root.signUp]);
    this.onClose.emit();
  }

  getTitle() {
    let message = '';
    switch (this.type) {
      case AfterAttendeeSectionType.PARTICIPANTS: {
        message =
          this.rsvpType === RSVPOptionType.NO
            ? this.translateService.instant(
                'APP.EVENT_AFTER_ATTEND.GENERIC.PARTICIPATION_WITHDRAWN',
              )
            : this.translateService.instant(
                'APP.EVENT_AFTER_ATTEND.GENERIC.PARTICIPATION_CONFIRMED',
              );
        return message;
      }
      case AfterAttendeeSectionType.SIGN_UP: {
        return this.translateService.instant(
          'APP.EVENT_AFTER_ATTEND.GENERIC.CREATE_ACCOUNT_FOR_BETTER_EXPERIENCE',
        );
      }
      case AfterAttendeeSectionType.SOCIAL_MEDIA: {
        return this.translateService.instant(
          'APP.EVENT_AFTER_ATTEND.GENERIC.LETS_CONNECT',
        );
      }
      default:
        return '';
    }
  }

  getDescription() {
    let confirmationMessage = '';

    switch (this.type) {
      case AfterAttendeeSectionType.PARTICIPANTS: {
        if (
          this.attendee?.getEmail() &&
          this.attendee?.getEmail() !== '-' &&
          this.attendee?.getEmail().trim() !== ''
        ) {
          confirmationMessage = `${this.translateService.instant(
            'APP.EVENT_AFTER_ATTEND.GENERIC.CONFIRMATION_SENT',
          )} ${this.attendee?.getEmail()}`;
        } else {
          confirmationMessage = `${this.translateService.instant(
            'APP.EVENT_AFTER_ATTEND.GENERIC.CONFIRMATION_SENT_PHONE',
          )} ${this.attendee?.getPhone()}`;
        }
        return confirmationMessage;
      }
      case AfterAttendeeSectionType.SIGN_UP: {
        return this.translateService.instant(
          'APP.EVENT_AFTER_ATTEND.GENERIC.MANAGE_YOUR_TICKETS',
        );
      }
      case AfterAttendeeSectionType.SOCIAL_MEDIA: {
        return this.translateService.instant(
          'APP.EVENT_AFTER_ATTEND.GENERIC.CHECK_OUR_SOCIAL_MEDIA',
        );
      }
      default:
        return '';
    }
  }

  getSocialMediaSection() {
    const socialMediaSection = this.eventRsvpConfirmationPage?.sections.find(
      (x) =>
        x.type === EventRSVPConfirmationPageSectionType.SOCIAL_MEDIA &&
        x.visible,
    );
    if (!socialMediaSection) return;
    else {
      if (
        socialMediaSection.socialMediaLinks &&
        socialMediaSection.socialMediaLinks?.length > 0
      ) {
        return socialMediaSection;
      } else return;
    }
  }

  protected readonly AfterAttendeeSectionType = AfterAttendeeSectionType;
  protected readonly EventRSVPConfirmationPageSectionType =
    EventRSVPConfirmationPageSectionType;
}
